import __base_store from '@/store/__base_store'

/**
 * Store de días de entrega (modelo `delivery_day`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'delivery_day',
	},
})

